import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-canvas px-4 py-9 sm:px-6 sm:py-12" data-id="element-50" data-mp="1bmvduyo2iarr">
      <div className="mx-auto max-w-2xl" data-id="element-51" data-mp="1gk57yrmejalx">
        <h2 className="text-center font-display text-[1.2rem] font-extrabold uppercase leading-tight text-brand-deep sm:text-3xl" data-id="element-52" data-mp="249g4fwwpyiu9">
          Preguntas frecuentes
        </h2>

        <div className="mt-4 divide-y divide-gray-200 overflow-hidden rounded-xl border border-gray-200 bg-white" data-id="element-53" data-mp="28cw12t8sgj6y">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.pregunta} data-id="element-54" data-mp="2n822f2wxvtty" data-mpi={i}>
                <h3 data-id="element-55" data-mp="2n70qyxc0h5bp">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-3 px-3.5 py-2.5 text-left font-display text-[0.85rem] font-extrabold leading-snug text-brand-deep transition-colors duration-150 ease-out hover:bg-brand-soft focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-brand sm:px-4 sm:py-3 sm:text-base" data-id="element-56" data-mp="2n6r1dauvp06j">
                    <span data-id="element-57" data-mp="1oldwc77sfxfz">{faq.pregunta}</span>
                    <ChevronDownIcon className={`h-4 w-4 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-58" data-mp="1jkzooqa3mpih" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-59" data-mp="36giivuytzx1">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-60" data-mp="3udjbnsud6g9w">
                      <p className="px-3.5 pb-3 text-[0.82rem] leading-snug text-gray-600 sm:px-4 sm:pb-4 sm:text-[0.95rem]" data-id="element-61" data-mp="2c9ntesx1ltuc">
                        {faq.respuesta}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}